import ViewAllProducts from './ViewAllProducts';
import { connect } from './connect';

export default connect(ViewAllProducts);
